<template>
  <div class="life-container">
    <el-row>
      <el-col class="title" :span="12">
        <p>Life at Kiwigame</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="life_kiwi" :span="24">
        <swiper-view :imageList="images"></swiper-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SwiperView from '@/components/SwiperComponent/MultSwiper.vue'

export default {
  data: function () {
    return {
      imageRoot: process.env.VUE_APP_IMAGE_PATH
    }
  },
  computed: {
    images: function () {
      return [
        `${this.imageRoot}/home/life_at_kiwigame/pic1.png`,
        `${this.imageRoot}/home/life_at_kiwigame/pic2.png`,
        `${this.imageRoot}/home/life_at_kiwigame/pic3.png`
      ]
    }
  },
  components: {
    SwiperView
  }
}
</script>

<style lang="scss" scoped>
.life-container{
  .title{
    @include normalTitle('#{$imageRoot}/home/title_dot.png',45px, 45px, -40px, 75px, 2, 76.8px);
  }
}
.life_kiwi{
  width: 840px;
}
</style>
